"use strict";

var badgesAnimationDone = 0;

IREP.badgesBand = (function () {
    var totalBadgeTimeline = new TimelineLite({ paused: true });

    var init = function () {
        var badges = $('.divBadges');
        badges.css('opacity', "0");
        badges.css('left', "40px");

        var delay = 0.09;

        //  totalBadgeTimeline.staggerTo($(".divBadges"), .15,  { opacity: 1, marginLeft:"0px", ease:Linear.easeNone, }, 0.25, .75);

        $.each(badges, function (i, item) {
            var cntBadges = $('.divBadges').length;

            if ((cntBadges - i) < 15) {
                delay = delay + 0.010;
            }
            totalBadgeTimeline.add(TweenMax.to(item, delay, {
                opacity: 1,
                left: "0px",
                onStart: function () {
                    $('#litBadgeCount').css("opacity", i / cntBadges);                    
                    $('#litBadgeCount').text(i+1);
                }
            }));
        });
    };

    var BadgesTotalFadeIn = function (runMultipleTimes) {

        if ((runMultipleTimes === 1) || (badgesAnimationDone === 0)) {
            totalBadgeTimeline.pause(0);
            totalBadgeTimeline.play();

            badgesAnimationDone = 1;
        }
    };

    return {
        init: init,
        totalFadeIn: BadgesTotalFadeIn
    };
}());





